import React from 'react';
import styles from '../../assets/css/StudyInUk.module.css';
import { Link } from 'react-router-dom';
import classNames from 'classnames';


function Property() {
    return (
        <div className={classNames(styles.mainContainer, styles.propertyMain)}>
            <div className={styles.leftContainer}>
                <div className={styles.logoText}>
                    <div className={styles.ukbdtext}>
                        <p className={styles.title}> Property Management</p>
                    </div>
                </div>
                <div className={styles.topTextN}>
                    <p className={classNames(styles.topinnertext, styles._property_)}>
                        <span className={styles.slide_text_title}>Dedicated care & protection for your assets in Bangladesh!</span>
                        <br />
                        <br />
                        <span className={styles.slide_text_body}>
                            Let us take the burden off your shoulders & turn your dreams into a reality. We understand the challenges faced by non-resident Bangladeshis in managing their properties and assets. Our comprehensive business and marketing solutions empower you to protect and grow your investments, making your dreams a tangible success. Leave the worries behind and entrust us with the care and management of your properties and assets. Our expert team is committed to transforming your aspirations into actuality, offering unrivaled support every step of the way. Together, we'll navigate the challenges, bringing your vision to life with unparalleled expertise and support. Maximize the potential of your properties and assets back home with our exclusive professionals and enginering support for non-resident Bangladeshis. With our comprehensive range of property management solutions will cater your properties and assets with the utmost care and expertise. We'll help you achieve your goals and transform your dreams into a flourishing reality. Let us be your trusted partner in turning those aspirations into tangible accomplishments.
                        </span>
                    </p>
                </div>
            </div>
        </div>
    );

}

export default Property;